import React from 'react';
import styles from 'assets/styles/modules/agencies-flow-management.module.scss';
import { Button, Dropdown, Menu, message, Space, Table, Tooltip } from 'antd';
import { useStore } from 'store';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { DateFormats, StringFormats } from 'js/config/config';
import i18n from 'js/tools/i18n';
import { FileType } from 'js/constants/enum/fileType';
import DownoadFileButtons from '../donwload-file';
import { Report } from 'js/constants/types/report';

const { shortDateFormat } = StringFormats;

interface IProps {
    reportResult?: any[];
    // onEdit: any;
    selectedReport: any;
    downloadFile: (event, fileType: FileType) => Promise<void>;
}

const ReportTable = (props: IProps) => {
    const { t } = useTranslation();
    const setLoading = useStore((state) => state.setLoading);
    const currentLanguage = i18n.language;

    const buttonsDownload = [
        {
            type: FileType.Excel,
            text: 'xlsx',
            disabled: props.reportResult?.length == 0 ? true : false,
            tooltip: t('commonClass.downloadXlsx'),
            order: 10,
            key: 1,
        }
    ];

    const columns = [
        {
            title: t('reports.numeroVoucher'),
            dataIndex: 'numeroVoucher',
            key: 1,
            align: 'center' as const
        },
        {
            title: t('reports.numeroPolizza'),
            dataIndex: 'numeroPolizza',
            key: 2,
            align: 'center' as const
        },
        {
            title: t('reports.idMovimento'),
            dataIndex: 'idMovimento',
            key: 3,
            align: 'center' as const
        },
        {
            title: t('reports.dataOperazione'),
            dataIndex: 'dataOperazione',
            key: 4,
            align: 'center' as const
        },
        {
            title: t('reports.dataPresoApp'),
            dataIndex: 'dataPresoApp',
            key: 5,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.targa'),
            dataIndex: 'targa',
            key: 6,
            align: 'center' as const
        },
        {
            title: t('reports.nome'),
            dataIndex: 'nome',
            key: 7,
            align: 'center' as const
        },
        {
            title: t('reports.cognome'),
            dataIndex: 'cognome',
            key: 8,
            align: 'center' as const
        },
        {
            title: t('reports.vat'),
            dataIndex: 'vat',
            key: 9,
            align: 'center' as const
        },
        {
            title: t('reports.nomeFile'),
            dataIndex: 'nomeFile',
            key: 10,
            align: 'center' as const
        },
        {
            title: t('reports.dataSpool'),
            dataIndex: 'dataSpool',
            key: 11,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.idViasat'),
            dataIndex: 'idViasat',
            key: 12,
            align: 'center' as const
        },
        {
            title: t('reports.agenzia'),
            dataIndex: 'agenzia',
            key: 13,
            align: 'center' as const
        },
        {
            title: t('reports.dataAttivazione'),
            dataIndex: 'dataAttivazione',
            key: 14,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.spedito'),
            dataIndex: 'spedito',
            key: 15,
            align: 'center' as const
        },
        {
            title: t('reports.codiceInstallatore'),
            dataIndex: 'codiceInstallatore',
            key: 16,
            align: 'center' as const
        },
        {
            title: t('reports.dataSped'),
            dataIndex: 'dataSped',
            key: 17,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.tipoProdotto'),
            dataIndex: 'tipoProdotto',
            key: 18,
            align: 'center' as const
        },
        {
            title: t('reports.terminaleProprio'),
            dataIndex: 'terminaleProprio',
            key: 19,
            align: 'center' as const
        },
        {
            title: t('reports.codiceLast'),
            dataIndex: 'codiceLast',
            key: 20,
            align: 'center' as const
        },
        {
            title: t('reports.decorrenza'),
            dataIndex: 'decorrenza',
            key: 21,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.dataInizioServizio'),
            dataIndex: 'dataInizioServizio',
            key: 22,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.dataFineServizio'),
            dataIndex: 'dataFineServizio',
            key: 23,
            align: 'center' as const,
            render: (date: string) => moment(new Date(date)).format("DD/MM/YYYY"),
        },
        {
            title: t('reports.descrizione'),
            dataIndex: 'descrizione',
            key: 24,
            align: 'center' as const
        }
    ];

    // TODO: aggiungere alla classe report una proprietà "Type" su cui effettuare lo switch
    //       appena verrà definita la nuova base dati per i report.
    if (props.reportResult && props.reportResult.length > 0 && props.selectedReport != 331 && props.selectedReport != 334
        && props.selectedReport != 336 && props.selectedReport != 337 && props.selectedReport != 338) {
        return (
            <>
                <DownoadFileButtons buttonsProperty={buttonsDownload} downloadFile={props.downloadFile} />
                <br></br>
                <section className={styles.table}>
                    <Table
                        columns={columns}
                        dataSource={props.reportResult}
                        rowKey="numeroVoucher"
                        pagination={{ pageSize: 20, showSizeChanger: false, position: ['bottomRight'] }}
                        size="small"
                        scroll={{ x: 800 }}
                        footer={() => (
                            <div className={styles.footer}>
                                {t('commonClass.total')}: {props.reportResult?.length || 0}
                            </div>
                        )}
                    ></Table>
                </section>
            </>
        );    
    } else if (props.reportResult && props.reportResult.length > 0 
               && (props.selectedReport == 331 || props.selectedReport == 334 || props.selectedReport == 336 
                   || props.selectedReport == 337 || props.selectedReport == 338)) {
        return (
            <>
                <DownoadFileButtons buttonsProperty={buttonsDownload} downloadFile={props.downloadFile} />
                <br></br>
                <section className={styles.table}>
                    <p>{t('reports.clickDownloadBtn')}</p>
                </section>
            </>
        );    
    } else {
        return (
            <>                
                <section className={styles.table}>
                    <p>NO DATA</p>
                </section>
            </>
        );    
    }
};

export default ReportTable;
